function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var r = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty,
    p = Object.prototype.propertyIsEnumerable;

var t = function t(l, e, C) {
  return e in l ? r(l, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: C
  }) : l[e] = C;
},
    n = function n(l, e) {
  for (var C in e || (e = {})) {
    d.call(e, C) && t(l, C, e[C]);
  }

  if (o) {
    var _iterator = _createForOfIteratorHelper(o(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var C = _step.value;
        p.call(e, C) && t(l, C, e[C]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return l;
};

import * as i from "react";

function w(l) {
  return i.createElement("svg", n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, l), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7101 14H15.5001L19.7401 18.26C20.1501 18.67 20.1501 19.34 19.7401 19.75C19.3301 20.16 18.6601 20.16 18.2501 19.75L14.0001 15.5V14.71L13.7301 14.43C12.3301 15.63 10.4201 16.25 8.39014 15.91C5.61014 15.44 3.39014 13.12 3.05014 10.32C2.53014 6.09 6.09014 2.53 10.3201 3.05C13.1201 3.39 15.4401 5.61 15.9101 8.39C16.2501 10.42 15.6301 12.33 14.4301 13.73L14.7101 14ZM5.00014 9.5C5.00014 11.99 7.01014 14 9.50014 14C11.9901 14 14.0001 11.99 14.0001 9.5C14.0001 7.01 11.9901 5 9.50014 5C7.01014 5 5.00014 7.01 5.00014 9.5Z",
    fill: "black"
  }));
}

export { w as ReactComponent };